export default __webpack_public_path__ + "static/media/BARR Eng..c8398f5d.png";